import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class ChipsService {
  duplicateCheck: any = {};
  duplicatesFound: Array<any> = [];
  doValidation: boolean;

  constructor() {}

  get isDuplicate() {
    return this.duplicatesFound.length > 0;
  }

  get getDuplicateValue() {
    return this.duplicatesFound;
  }

  get getDuplicateCheck() {
    return this.duplicateCheck;
  }

  set setDoValidation(validationValue: boolean) {
    this.doValidation = validationValue;
  }

  resetChipsData() {
    this.duplicateCheck = {};
    this.duplicatesFound = [];
  }

  addChips(chipList: string[]) {
    for (const chip of chipList) {
      this.addValidatorValues(chip);
    }
  }

  addValidatorValues(value: string): any {
    if (this.doValidation) {
      if (!this.duplicateCheck[value]) {
        this.duplicateCheck[value] = true;
      } else {
        this.duplicatesFound.push(value);
      }
    }
  }

  removeValidatorValues(value: string) {
    if (this.doValidation) {
      if (this.duplicatesFound.includes(value)) {
        const index = this.duplicatesFound.indexOf(value);
        this.duplicatesFound.splice(index, 1);
      } else {
        delete this.duplicateCheck[value];
      }
    }
  }
}
